<template>
    <div component="navigation">
        <div v-bar class="vb">
            <div class="list">
                <nav></nav>
                <nav user-role="logged" v-if="getIsLoggedIn">
                    <nav-item v-for="item in getPrivateMenu" :key="item.link" :item="item" />
                </nav>
                <nav>
                    <nav-item
                        v-for="item in getPublicMenu"
                        :size="getIsLoggedIn ? 'small' : ''"
                        :key="item.link"
                        :item="item"
                    />
                </nav>
            </div>
        </div>
        <div class="footer">
            <btn
                :icon="'power_settings_new'"
                :size="'big'"
                :text="'Login'"
                @click="openAuthPopup"
                v-if="!getIsLoggedIn"
            />
            <btn :icon="'power_settings_new'" :size="'big'" :text="'Logout'" @click="logout" v-if="getIsLoggedIn" />
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';

import NavItem from './NavItem.vue';

/**
 * Hlavná navigácia
 */
export default {
    name: 'Navigation',

    methods: {
        ...mapActions(['openAuthPopup']),

        logout() {
            this.$store.dispatch('logout', true);
            this.$store.commit('closeAllPopups');
            if (this.$route.name != 'home') {
                this.$router.push({ name: 'home' });
            }
        },
    },

    computed: {
        ...mapGetters(['getPrivateMenu', 'getPublicMenu', 'getIsLoggedIn', 'hasRole', 'getMenuSection']),
    },

    components: {
        NavItem,
    },
};
</script>
<style lang="less" scoped>
[component='navigation'] {
    display: flex;
    flex-direction: column;
    height: 100%;

    nav {
        padding: 1px;
    }

    [user-role='logged'] {
        margin-bottom: 15px;
    }

    .list {
        display: flex !important;
        flex-direction: column;
        justify-content: space-between;
    }

    .footer {
        margin-top: 30px;

        @media (max-width: 760px) {
            margin-top: 10px;
        }

        button {
            width: 100%;
        }
    }
}
</style>
<docs>
    ## Zložitejší Navigation komponent
    ### Spolu s odokumentovanou funkciou
</docs>
